export var LoginRadiusSDK = (function () {
  !(function (e, t) {
    'use strict';
    var i = (function () {
      var t = function () {
          for (
            var t = e.location.hash ? e.location.hash.substr(1).split('&') : [],
              i = {},
              n = 0;
            n < t.length;
            n++
          ) {
            var s = t[n].split('=');
            i[s[0]] = decodeURIComponent(s[1]);
          }
          return i;
        },
        i = function (t) {
          var i = [];
          for (var n in t) i.push(n + '=' + encodeURIComponent(t[n]));
          e.location.hash = i.join('&');
        };
      return {
        get: function (e) {
          var i = t();
          return e ? i[e] : i;
        },
        add: function (e) {
          var n = t();
          for (var s in e) n[s] = e[s];
          i(n);
        },
        remove: function (e) {
          e = 'string' == typeof e ? [e] : e;
          for (var n = t(), s = 0; s < e.length; s++) delete n[e[s]];
          i(n);
        },
        clear: function () {
          i({});
        },
      };
    })();
    e.hash = i;
  })(window);
  var e = function (e) {
      return (
        (e &&
          decodeURIComponent(
            document.cookie.replace(
              new RegExp(
                '(?:(?:^|.*;)\\s*' +
                  encodeURIComponent(e).replace(/[\-\.\+\*]/g, '\\$&') +
                  '\\s*\\=\\s*([^;]*).*$)|^.*$',
              ),
              '$1',
            ),
          )) ||
        null
      );
    },
    t = function (e, t, i, n, s, a) {
      if (!e || /^(?:expires|max\-age|path|domain|secure)$/i.test(e)) return !1;
      var l = '',
        r = function (e) {
          if (e === 1 / 0) return 'Fri, 31 Dec 9999 23:59:59 GMT';
          var t = new Date();
          return t.setTime(t.getTime() + 1e3 * e), t.toGMTString();
        };
      if (i)
        switch (i.constructor) {
          case Number:
            l = '; expires=' + r(i) + i === 1 / 0 ? '' : '; max-age=' + i;
            break;
          case String:
            l = '; expires=' + i;
            break;
          case Date:
            l = '; expires=' + i.toUTCString();
        }
      return (
        (document.cookie =
          encodeURIComponent(e) +
          '=' +
          encodeURIComponent(t) +
          l +
          (s ? '; domain=' + s : '') +
          (n ? '; path=' + n : '') +
          (a ? '; secure' : '')),
        !0
      );
    },
    i = 'https://api.loginradius.com',
    n = 'LRTokenKey',
    s = {},
    a = {},
    l = {
      905: {
        Description:
          'The LoginRadius access token is invalid, please use the correct or valid access token in order to process this request.',
        ErrorCode: 905,
        Message: 'Access token is invalid'
      },
      906: {
        Description: 'The LoginRadius access token has expired, please request a new token from LoginRadius API.',
        ErrorCode: 906,
        Message: 'Access token has expired',
      },
      920: {
        Description:
          'The provided LoginRadius API key is invalid, please use a valid API key of your LoginRadius account.',
        ErrorCode: 920,
        Message: 'API key is invalid',
      },
      1e3: {
        Description: 'Oops something went wrong, Please try again.',
        ErrorCode: 1e3,
        Message: 'Oops something went wrong, Please try again.',
      },
      429: {
        Description: 'Too many request in a particular timeframe.',
        ErrorCode: 429,
        Message: 'Too many request in a particular timeframe.',
      },
    },
    r = {};

  function o(e) {
    if (!window[e]) return !1;
    var t = 'test',
      i = window[e];
    try {
      return i.setItem(t, '1'), i.removeItem(t), !0;
    } catch (e) {
      return !1;
    }
  }

  function u(t) {
    return o('localStorage') &&
      null !== localStorage.getItem(t) &&
      void 0 !== localStorage.getItem(t) &&
      '' !== localStorage.getItem(t)
      ? localStorage.getItem(t)
      : o('sessionStorage') &&
        null !== sessionStorage.getItem(t) &&
        void 0 !== sessionStorage.getItem(t) &&
        '' !== sessionStorage.getItem(t)
      ? sessionStorage.getItem(t)
      : e(t);
  }
  (r.isauthenticated = !1),
    (r.setLoginCallback = function (e) {
      r.onlogin = e;
    }),
    (r.oneTouchLoginApi = {}),
    (r.oneTouchLoginApi = {
      oneTouchLoginByEmail: function (e, t, i, n, a) {
        if (s.checkJson(e)) return a(s.message('oneTouchLoginByEmailModel'));
        var l = {};
        s.isNull(t) || (l.oneTouchLoginEmailTemplate = t),
          s.isNull(i) || (l.redirecturl = i),
          s.isNull(n) || (l.welcomeemailtemplate = n);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/onetouchlogin/email',
          l,
          e,
          a,
        );
      },
      oneTouchLoginByPhone: function (e, t, i) {
        if (s.checkJson(e)) return i(s.message('oneTouchLoginByPhoneModel'));
        var n = {};
        s.isNull(t) || (n.smsTemplate = t);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/onetouchlogin/phone',
          n,
          e,
          i,
        );
      },
      oneTouchLoginOTPVerification: function (e, t, i, n, a) {
        if (s.isNull(e)) return a(s.message('otp'));
        if (s.isNull(t)) return a(s.message('phone'));
        var l = {};
        (l.otp = e),
          s.isNull(i) || (l.fields = i),
          s.isNull(n) || (l.smsTemplate = n);
        var r = {};
        r.phone = t;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/onetouchlogin/phone/verify',
          l,
          r,
          a,
        );
      },
      oneTouchEmailVerification: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('verificationToken'));
        var n = {};
        (n.verificationToken = e), s.isNull(t) || (n.welcomeEmailTemplate = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/email/onetouchlogin',
          n,
          {},
          i,
        );
      },
      oneTouchLoginPing: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('clientGuid'));
        var n = {};
        (n.clientGuid = e), s.isNull(t) || (n.fields = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/smartlogin/ping',
          n,
          {},
          i,
        );
      },
    }),
    (r.authenticationApi = {
      getSecurityQuestionsByEmail: function (e, t) {
        if (s.isNull(e)) return t(s.message('email'));
        var i = {};
        i.email = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/securityquestion/email',
          i,
          {},
          t,
        );
      },
      getSecurityQuestionsByUserName: function (e, t) {
        if (s.isNull(e)) return t(s.message('userName'));
        var i = {};
        i.userName = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/securityquestion/username',
          i,
          {},
          t,
        );
      },
      getSecurityQuestionsByPhone: function (e, t) {
        if (s.isNull(e)) return t(s.message('phone'));
        var i = {};
        i.phone = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/securityquestion/phone',
          i,
          {},
          t,
        );
      },
      getSecurityQuestionsByAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/securityquestion/accesstoken',
          i,
          {},
          t,
        );
      },
      authValidateAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/access_token/validate',
          i,
          {},
          t,
        );
      },
      authInValidateAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        var n = {};
        (n.access_token = e), null !== t && (n.preventRefresh = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/access_token/invalidate',
          n,
          {},
          i,
        );
      },
      getAccessTokenInfo: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall('GET', 'identity/v2/auth/access_token', i, {}, t);
      },
      getProfileByAccessToken: function (e, t, i, n, a, l) {
        if (s.isNull(e)) return l(s.message('accessToken'));
        var r = {};
        (r.access_token = e),
          s.isNull(t) || (r.fields = t),
          s.isNull(i) || (r.emailTemplate = i),
          s.isNull(n) || (r.verificationUrl = n),
          s.isNull(a) || (r.welcomeEmailTemplate = a);
        return s.xhttpCall('GET', 'identity/v2/auth/account', r, {}, l);
      },
      sendWelcomeEmail: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        var n = {};
        (n.access_token = e), s.isNull(t) || (n.welcomeEmailTemplate = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/account/sendwelcomeemail',
          n,
          {},
          i,
        );
      },
      updateProfileByAccessToken: function (e, t, i, n, a, l, r, o) {
        if (s.isNull(e)) return o(s.message('accessToken'));
        if (s.checkJson(t)) return o(s.message('userProfileUpdateModel'));
        var u = {};
        (u.access_token = e),
          s.isNull(i) || (u.emailTemplate = i),
          s.isNull(n) || (u.fields = n),
          null !== a && (u.nullSupport = a),
          s.isNull(l) || (u.smsTemplate = l),
          s.isNull(r) || (u.verificationUrl = r);
        return s.xhttpCall('PUT', 'identity/v2/auth/account', u, t, o);
      },
      deleteAccountWithEmailConfirmation: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        var a = {};
        (a.access_token = e),
          s.isNull(t) || (a.deleteUrl = t),
          s.isNull(i) || (a.emailTemplate = i);
        return s.xhttpCall('DELETE', 'identity/v2/auth/account', a, {}, n);
      },
      deleteAccountByDeleteToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('deletetoken'));
        var i = {};
        i.deletetoken = e;
        return s.xhttpCall('GET', 'identity/v2/auth/account/delete', i, {}, t);
      },
      unlockAccountByToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t)) return i(s.message('unlockProfileModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall('PUT', 'identity/v2/auth/account/unlock', n, t, i);
      },
      getProfileByPing: function (e, t, i, n, a, l) {
        if (s.isNull(e)) return l(s.message('clientGuid'));
        var r = {};
        (r.clientGuid = e),
          s.isNull(t) || (r.emailTemplate = t),
          s.isNull(i) || (r.fields = i),
          s.isNull(n) || (r.verificationUrl = n),
          s.isNull(a) || (r.welcomeEmailTemplate = a);
        return s.xhttpCall('GET', 'identity/v2/auth/account/ping', r, {}, l);
      },
      checkEmailAvailability: function (e, t) {
        if (s.isNull(e)) return t(s.message('email'));
        var i = {};
        i.email = e;
        return s.xhttpCall('GET', 'identity/v2/auth/email', i, {}, t);
      },
      verifyEmail: function (e, t, i, n, a) {
        if (s.isNull(e)) return a(s.message('verificationToken'));
        var l = {};
        (l.verificationToken = e),
          s.isNull(t) || (l.fields = t),
          s.isNull(i) || (l.url = i),
          s.isNull(n) || (l.welcomeEmailTemplate = n);
        return s.xhttpCall('GET', 'identity/v2/auth/email', l, {}, a);
      },
      verifyEmailByOTP: function (e, t, i, n, a) {
        if (s.checkJson(e)) return a(s.message('emailVerificationByOtpModel'));
        var l = {};
        s.isNull(t) || (l.fields = t),
          s.isNull(i) || (l.url = i),
          s.isNull(n) || (l.welcomeEmailTemplate = n);
        return s.xhttpCall('PUT', 'identity/v2/auth/email', l, e, a);
      },
      addEmail: function (e, t, i, n, a, l) {
        if (s.isNull(e)) return l(s.message('accessToken'));
        if (s.isNull(t)) return l(s.message('email'));
        if (s.isNull(i)) return l(s.message('type'));
        var r = {};
        (r.access_token = e),
          s.isNull(n) || (r.emailTemplate = n),
          s.isNull(a) || (r.verificationUrl = a);
        var o = {};
        (o.email = t), (o.type = i);
        return s.xhttpCall('POST', 'identity/v2/auth/email', r, o, l);
      },
      removeEmail: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.isNull(t)) return i(s.message('email'));
        var n = {};
        n.access_token = e;
        var a = {};
        a.email = t;
        return s.xhttpCall('DELETE', 'identity/v2/auth/email', n, a, i);
      },
      loginByEmail: function (e, t, i, n, a, l) {
        if (s.checkJson(e)) return l(s.message('emailAuthenticationModel'));
        var r = {};
        s.isNull(t) || (r.emailTemplate = t),
          s.isNull(i) || (r.fields = i),
          s.isNull(n) || (r.loginUrl = n),
          s.isNull(a) || (r.verificationUrl = a);
        return s.xhttpCall('POST', 'identity/v2/auth/login', r, e, l);
      },
      loginByUserName: function (e, t, i, n, a, l) {
        if (s.checkJson(e)) return l(s.message('userNameAuthenticationModel'));
        var r = {};
        s.isNull(t) || (r.emailTemplate = t),
          s.isNull(i) || (r.fields = i),
          s.isNull(n) || (r.loginUrl = n),
          s.isNull(a) || (r.verificationUrl = a);
        return s.xhttpCall('POST', 'identity/v2/auth/login', r, e, l);
      },
      forgotPassword: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('email'));
        if (s.isNull(t)) return n(s.message('resetPasswordUrl'));
        var a = {};
        (a.resetPasswordUrl = t), s.isNull(i) || (a.emailTemplate = i);
        var l = {};
        l.email = e;
        return s.xhttpCall('POST', 'identity/v2/auth/password', a, l, n);
      },
      resetPasswordBySecurityAnswerAndEmail: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPasswordBySecurityAnswerAndEmailModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/password/securityanswer',
          {},
          e,
          t,
        );
      },
      resetPasswordBySecurityAnswerAndPhone: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPasswordBySecurityAnswerAndPhoneModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/password/securityanswer',
          {},
          e,
          t,
        );
      },
      resetPasswordBySecurityAnswerAndUserName: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPasswordBySecurityAnswerAndUserNameModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/password/securityanswer',
          {},
          e,
          t,
        );
      },
      resetPasswordByResetToken: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPasswordByResetTokenModel'));
        return s.xhttpCall('PUT', 'identity/v2/auth/password/reset', {}, e, t);
      },
      resetPasswordByEmailOTP: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPasswordByEmailAndOtpModel'));
        return s.xhttpCall('PUT', 'identity/v2/auth/password/reset', {}, e, t);
      },
      resetPasswordByOTPAndUserName: function (e, t) {
        if (s.checkJson(e)) return t(s.message('resetPasswordByUserNameModel'));
        return s.xhttpCall('PUT', 'identity/v2/auth/password/reset', {}, e, t);
      },
      changePassword: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('newPassword'));
        if (s.isNull(i)) return n(s.message('oldPassword'));
        var a = {};
        a.access_token = e;
        var l = {};
        (l.newPassword = t), (l.oldPassword = i);
        return s.xhttpCall('PUT', 'identity/v2/auth/password/change', a, l, n);
      },
      unlinkSocialIdentities: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('provider'));
        if (s.isNull(i)) return n(s.message('providerId'));
        var a = {};
        a.access_token = e;
        var l = {};
        (l.provider = t), (l.providerId = i);
        return s.xhttpCall(
          'DELETE',
          'identity/v2/auth/socialidentity',
          a,
          l,
          n,
        );
      },
      linkSocialIdentities: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.isNull(t)) return i(s.message('candidateToken'));
        var n = {};
        n.access_token = e;
        var a = {};
        a.candidateToken = t;
        return s.xhttpCall('POST', 'identity/v2/auth/socialidentity', n, a, i);
      },
      linkSocialIdentitiesByPing: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.isNull(t)) return i(s.message('clientGuid'));
        var n = {};
        n.access_token = e;
        var a = {};
        a.clientGuid = t;
        return s.xhttpCall('POST', 'identity/v2/auth/socialidentity', n, a, i);
      },
      setOrChangeUserName: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.isNull(t)) return i(s.message('username'));
        var n = {};
        n.access_token = e;
        var a = {};
        a.username = t;
        return s.xhttpCall('PUT', 'identity/v2/auth/username', n, a, i);
      },
      checkUserNameAvailability: function (e, t) {
        if (s.isNull(e)) return t(s.message('username'));
        var i = {};
        i.username = e;
        return s.xhttpCall('GET', 'identity/v2/auth/username', i, {}, t);
      },
      acceptPrivacyPolicy: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        var n = {};
        (n.access_token = e), s.isNull(t) || (n.fields = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/privacypolicy/accept',
          n,
          {},
          i,
        );
      },
      getPrivacyPolicyHistoryByAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/privacypolicy/history',
          i,
          {},
          t,
        );
      },
      userRegistrationByEmail: function (e, t, i, n, a, l, r, o) {
        if (s.checkJson(e)) return o(s.message('authUserRegistrationModel'));
        if (s.isNull(t)) return o(s.message('sott'));
        var u = {};
        (u.sott = t),
          s.isNull(i) || (u.emailTemplate = i),
          s.isNull(n) || (u.fields = n),
          s.isNull(a) || (u.options = a),
          s.isNull(l) || (u.verificationUrl = l),
          s.isNull(r) || (u.welcomeEmailTemplate = r);
        return s.xhttpCall('POST', 'identity/v2/auth/register', u, e, o);
      },
      userRegistrationByCaptcha: function (e, t, i, n, a, l, r, o) {
        if (s.checkJson(e))
          return o(s.message('authUserRegistrationModelWithCaptcha'));
        var u = {};
        s.isNull(t) || (u.emailTemplate = t),
          s.isNull(i) || (u.fields = i),
          s.isNull(n) || (u.options = n),
          s.isNull(a) || (u.smsTemplate = a),
          s.isNull(l) || (u.verificationUrl = l),
          s.isNull(r) || (u.welcomeEmailTemplate = r);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/register/captcha',
          u,
          e,
          o,
        );
      },
      authResendEmailVerification: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('email'));
        var a = {};
        s.isNull(t) || (a.emailTemplate = t),
          s.isNull(i) || (a.verificationUrl = i);
        var l = {};
        l.email = e;
        return s.xhttpCall('PUT', 'identity/v2/auth/register', a, l, n);
      },
    }),
    (r.configurationApi = {}),
    (r.configurationApi = {
      getConfigurations: function (e) {
        return s.xhttpCall('GET', 'ciam/appinfo', {}, null, e);
      },
      getServerInfo: function (e, t) {
        var i = {};
        null !== e && (i.timeDifference = e);
        return s.xhttpCall('GET', 'identity/v2/serverinfo', i, {}, t);
      },
    }),
    (r.multiFactorAuthenticationApi = {}),
    (r.multiFactorAuthenticationApi = {
      mfaConfigureByAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        var n = {};
        (n.access_token = e), s.isNull(t) || (n.smsTemplate2FA = t);
        return s.xhttpCall('GET', 'identity/v2/auth/account/2fa', n, {}, i);
      },
      mfaUpdateSetting: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.checkJson(t))
          return n(s.message('multiFactorAuthModelWithLockout'));
        var a = {};
        (a.access_token = e), s.isNull(i) || (a.fields = i);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/2fa/verification/otp',
          a,
          t,
          n,
        );
      },
      mfaUpdateByAccessToken: function (e, t, i, n, a) {
        if (s.isNull(e)) return a(s.message('accessToken'));
        if (s.checkJson(t))
          return a(s.message('multiFactorAuthModelByGoogleAuthenticatorCode'));
        var l = {};
        (l.access_token = e),
          s.isNull(i) || (l.fields = i),
          s.isNull(n) || (l.smsTemplate = n);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/2fa/verification/googleauthenticatorcode',
          l,
          t,
          a,
        );
      },
      mfaUpdatePhoneNumberByToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('phoneNo2FA'));
        var a = {};
        (a.access_token = e), s.isNull(i) || (a.smsTemplate2FA = i);
        var l = {};
        l.phoneNo2FA = t;
        return s.xhttpCall('PUT', 'identity/v2/auth/account/2fa', a, l, n);
      },
      mfaResetGoogleAuthByToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        var n = {};
        n.access_token = e;
        var a = {};
        a.googleauthenticator = t;
        return s.xhttpCall(
          'DELETE',
          'identity/v2/auth/account/2fa/authenticator',
          n,
          a,
          i,
        );
      },
      mfaResetSMSAuthByToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        var n = {};
        n.access_token = e;
        var a = {};
        a.otpauthenticator = t;
        return s.xhttpCall(
          'DELETE',
          'identity/v2/auth/account/2fa/authenticator',
          n,
          a,
          i,
        );
      },
      mfaBackupCodeByAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/account/2fa/backupcode',
          i,
          {},
          t,
        );
      },
      mfaResetBackupCodeByAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/account/2fa/backupcode/reset',
          i,
          {},
          t,
        );
      },
      mfaEmailOtpByAccessToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('emailId'));
        var a = {};
        (a.access_token = e),
          (a.emailId = t),
          s.isNull(i) || (a.emailTemplate2FA = i);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/account/2fa/otp/email',
          a,
          {},
          n,
        );
      },
      mfaValidateEmailOtpByAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t))
          return i(s.message('multiFactorAuthModelByEmailOtpWithLockout'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/2fa/verification/otp/email',
          n,
          t,
          i,
        );
      },
      mfaResetEmailOtpAuthenticatorByAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall(
          'DELETE',
          'identity/v2/auth/account/2fa/authenticator/otp/email',
          i,
          {},
          t,
        );
      },
      mfaSecurityQuestionAnswerByAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t))
          return i(s.message('securityQuestionAnswerModelByAccessToken'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/2fa/securityquestionanswer',
          n,
          t,
          i,
        );
      },
      mfaResetSecurityQuestionAuthenticatorByAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall(
          'DELETE',
          'identity/v2/auth/account/2fa/authenticator/securityquestionanswer',
          i,
          {},
          t,
        );
      },
      mfaLoginByEmail: function (e, t, i, n, a, l, r, o, u, c) {
        if (s.isNull(e)) return c(s.message('email'));
        if (s.isNull(t)) return c(s.message('password'));
        var m = {};
        s.isNull(i) || (m.emailTemplate = i),
          s.isNull(n) || (m.fields = n),
          s.isNull(a) || (m.loginUrl = a),
          s.isNull(l) || (m.smsTemplate = l),
          s.isNull(r) || (m.smsTemplate2FA = r),
          s.isNull(o) || (m.verificationUrl = o),
          s.isNull(u) || (m.emailTemplate2FA = u);
        var p = {};
        (p.email = e), (p.password = t);
        return s.xhttpCall('POST', 'identity/v2/auth/login/2fa', m, p, c);
      },
      mfaLoginByUserName: function (e, t, i, n, a, l, r, o, u, c) {
        if (s.isNull(e)) return c(s.message('password'));
        if (s.isNull(t)) return c(s.message('username'));
        var m = {};
        s.isNull(i) || (m.emailTemplate = i),
          s.isNull(n) || (m.fields = n),
          s.isNull(a) || (m.loginUrl = a),
          s.isNull(l) || (m.smsTemplate = l),
          s.isNull(r) || (m.smsTemplate2FA = r),
          s.isNull(o) || (m.verificationUrl = o),
          s.isNull(u) || (m.emailTemplate2FA = u);
        var p = {};
        (p.password = e), (p.username = t);
        return s.xhttpCall('POST', 'identity/v2/auth/login/2fa', m, p, c);
      },
      mfaLoginByPhone: function (e, t, i, n, a, l, r, o, u, c) {
        if (s.isNull(e)) return c(s.message('password'));
        if (s.isNull(t)) return c(s.message('phone'));
        var m = {};
        s.isNull(i) || (m.emailTemplate = i),
          s.isNull(n) || (m.fields = n),
          s.isNull(a) || (m.loginUrl = a),
          s.isNull(l) || (m.smsTemplate = l),
          s.isNull(r) || (m.smsTemplate2FA = r),
          s.isNull(o) || (m.verificationUrl = o),
          s.isNull(u) || (m.emailTemplate2FA = u);
        var p = {};
        (p.password = e), (p.phone = t);
        return s.xhttpCall('POST', 'identity/v2/auth/login/2fa', m, p, c);
      },
      mfaValidateOTPByPhone: function (e, t, i, n, a, l, r, o, u) {
        if (s.checkJson(e))
          return u(s.message('multiFactorAuthModelWithLockout'));
        if (s.isNull(t)) return u(s.message('secondFactorAuthenticationToken'));
        var c = {};
        (c.secondFactorAuthenticationToken = t),
          s.isNull(i) || (c.fields = i),
          s.isNull(n) || (c.smsTemplate2FA = n),
          s.isNull(a) || (c.rbaBrowserEmailTemplate = a),
          s.isNull(l) || (c.rbaCityEmailTemplate = l),
          s.isNull(r) || (c.rbaCountryEmailTemplate = r),
          s.isNull(o) || (c.rbaIpEmailTemplate = o);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/login/2fa/verification/otp',
          c,
          e,
          u,
        );
      },
      mfaValidateGoogleAuthCode: function (e, t, i, n, a, l, r, o) {
        if (s.isNull(e)) return o(s.message('googleAuthenticatorCode'));
        if (s.isNull(t)) return o(s.message('secondFactorAuthenticationToken'));
        var u = {};
        (u.secondFactorAuthenticationToken = t),
          s.isNull(i) || (u.fields = i),
          s.isNull(n) || (u.rbaBrowserEmailTemplate = n),
          s.isNull(a) || (u.rbaCityEmailTemplate = a),
          s.isNull(l) || (u.rbaCountryEmailTemplate = l),
          s.isNull(r) || (u.rbaIpEmailTemplate = r);
        var c = {};
        c.googleAuthenticatorCode = e;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/login/2fa/verification/googleauthenticatorcode',
          u,
          c,
          o,
        );
      },
      mfaValidateBackupCode: function (e, t, i, n, a, l, r, o) {
        if (s.checkJson(e))
          return o(s.message('multiFactorAuthModelByBackupCode'));
        if (s.isNull(t)) return o(s.message('secondFactorAuthenticationToken'));
        var u = {};
        (u.secondFactorAuthenticationToken = t),
          s.isNull(i) || (u.fields = i),
          s.isNull(n) || (u.rbaBrowserEmailTemplate = n),
          s.isNull(a) || (u.rbaCityEmailTemplate = a),
          s.isNull(l) || (u.rbaCountryEmailTemplate = l),
          s.isNull(r) || (u.rbaIpEmailTemplate = r);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/login/2fa/verification/backupcode',
          u,
          e,
          o,
        );
      },
      mfaUpdatePhoneNumber: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('phoneNo2FA'));
        if (s.isNull(t)) return n(s.message('secondFactorAuthenticationToken'));
        var a = {};
        (a.secondFactorAuthenticationToken = t),
          s.isNull(i) || (a.smsTemplate2FA = i);
        var l = {};
        l.phoneNo2FA = e;
        return s.xhttpCall('PUT', 'identity/v2/auth/login/2fa', a, l, n);
      },
      mfaResendOTP: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('secondFactorAuthenticationToken'));
        var n = {};
        (n.secondFactorAuthenticationToken = e),
          s.isNull(t) || (n.smsTemplate2FA = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/2fa/resend',
          n,
          {},
          i,
        );
      },
      mfaEmailOTP: function (e, t, i, n) {
        if (s.checkJson(e)) return n(s.message('emailIdModel'));
        if (s.isNull(t)) return n(s.message('secondFactorAuthenticationToken'));
        var a = {};
        (a.secondFactorAuthenticationToken = t),
          s.isNull(i) || (a.emailTemplate2FA = i);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/login/2fa/otp/email',
          a,
          e,
          n,
        );
      },
      mfaValidateEmailOtp: function (e, t, i, n, a, l, r) {
        if (s.checkJson(e))
          return r(s.message('multiFactorAuthModelByEmailOtp'));
        if (s.isNull(t)) return r(s.message('secondFactorAuthenticationToken'));
        var o = {};
        (o.secondFactorAuthenticationToken = t),
          s.isNull(i) || (o.rbaBrowserEmailTemplate = i),
          s.isNull(n) || (o.rbaCityEmailTemplate = n),
          s.isNull(a) || (o.rbaCountryEmailTemplate = a),
          s.isNull(l) || (o.rbaIpEmailTemplate = l);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/login/2fa/verification/otp/email',
          o,
          e,
          r,
        );
      },
      mfaSecurityQuestionAnswer: function (e, t, i) {
        if (s.checkJson(e))
          return i(s.message('securityQuestionAnswerUpdateModel'));
        if (s.isNull(t)) return i(s.message('secondFactorAuthenticationToken'));
        var n = {};
        n.secondFactorAuthenticationToken = t;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/login/2fa/securityquestionanswer',
          n,
          e,
          i,
        );
      },
      mfaSecurityQuestionAnswerVerification: function (e, t, i, n, a, l, r) {
        if (s.checkJson(e))
          return r(s.message('securityQuestionAnswerUpdateModel'));
        if (s.isNull(t)) return r(s.message('secondFactorAuthenticationToken'));
        var o = {};
        (o.secondFactorAuthenticationToken = t),
          s.isNull(i) || (o.rbaBrowserEmailTemplate = i),
          s.isNull(n) || (o.rbaCityEmailTemplate = n),
          s.isNull(a) || (o.rbaCountryEmailTemplate = a),
          s.isNull(l) || (o.rbaIpEmailTemplate = l);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/login/2fa/verification/securityquestionanswer',
          o,
          e,
          r,
        );
      },
    }),
    (r.customObjectApi = {}),
    (r.customObjectApi = {
      createCustomObjectByToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('objectName'));
        if (s.checkJson(i)) return n(s.message('payload'));
        var a = {};
        (a.access_token = e), (a.objectName = t);
        return s.xhttpCall('POST', 'identity/v2/auth/customobject', a, i, n);
      },
      updateCustomObjectByToken: function (e, t, i, n, a, l) {
        if (s.isNull(e)) return l(s.message('accessToken'));
        if (s.isNull(t)) return l(s.message('objectName'));
        if (s.isNull(i)) return l(s.message('objectRecordId'));
        if (s.checkJson(n)) return l(s.message('payload'));
        var r = {};
        (r.access_token = e),
          (r.objectName = t),
          null !== a && (r.updateType = a);
        var o = 'identity/v2/auth/customobject/' + i;
        return s.xhttpCall('PUT', o, r, n, l);
      },
      getCustomObjectByToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.isNull(t)) return i(s.message('objectName'));
        var n = {};
        (n.access_token = e), (n.objectName = t);
        return s.xhttpCall('GET', 'identity/v2/auth/customobject', n, {}, i);
      },
      getCustomObjectByRecordIDAndToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('objectName'));
        if (s.isNull(i)) return n(s.message('objectRecordId'));
        var a = {};
        (a.access_token = e), (a.objectName = t);
        var l = 'identity/v2/auth/customobject/' + i;
        return s.xhttpCall('GET', l, a, {}, n);
      },
      deleteCustomObjectByToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('objectName'));
        if (s.isNull(i)) return n(s.message('objectRecordId'));
        var a = {};
        (a.access_token = e), (a.objectName = t);
        var l = 'identity/v2/auth/customobject/' + i;
        return s.xhttpCall('DELETE', l, a, {}, n);
      },
    }),
    (r.customRegistrationDataApi = {}),
    (r.customRegistrationDataApi = {
      authGetRegistrationData: function (e, t, i, n, a) {
        if (s.isNull(e)) return a(s.message('type'));
        var l = {};
        null !== t && (l.limit = t),
          s.isNull(i) || (l.parentId = i),
          null !== n && (l.skip = n);
        var r = 'identity/v2/auth/registrationdata/' + e;
        return s.xhttpCall('GET', r, l, {}, a);
      },
      validateRegistrationDataCode: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('code'));
        if (s.isNull(t)) return i(s.message('recordId'));
        var n = {};
        (n.code = e), (n.recordId = t);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/registrationdata/validatecode',
          {},
          n,
          i,
        );
      },
    }),
    (r.smartLoginApi = {}),
    (r.smartLoginApi = {
      smartLoginTokenVerification: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('verificationToken'));
        var n = {};
        (n.verificationToken = e), s.isNull(t) || (n.welcomeEmailTemplate = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/email/smartlogin',
          n,
          {},
          i,
        );
      },
      smartLoginByEmail: function (e, t, i, n, a, l) {
        if (s.isNull(e)) return l(s.message('clientGuid'));
        if (s.isNull(t)) return l(s.message('email'));
        var r = {};
        (r.clientGuid = e),
          (r.email = t),
          s.isNull(i) || (r.redirectUrl = i),
          s.isNull(n) || (r.smartLoginEmailTemplate = n),
          s.isNull(a) || (r.welcomeEmailTemplate = a);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/smartlogin',
          r,
          {},
          l,
        );
      },
      smartLoginByUserName: function (e, t, i, n, a, l) {
        if (s.isNull(e)) return l(s.message('clientGuid'));
        if (s.isNull(t)) return l(s.message('username'));
        var r = {};
        (r.clientGuid = e),
          (r.username = t),
          s.isNull(i) || (r.redirectUrl = i),
          s.isNull(n) || (r.smartLoginEmailTemplate = n),
          s.isNull(a) || (r.welcomeEmailTemplate = a);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/smartlogin',
          r,
          {},
          l,
        );
      },
      smartLoginPing: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('clientGuid'));
        var n = {};
        (n.clientGuid = e), s.isNull(t) || (n.fields = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/smartlogin/ping',
          n,
          {},
          i,
        );
      },
    }),
    (r.phoneAuthenticationApi = {}),
    (r.phoneAuthenticationApi = {
      loginByPhone: function (e, t, i, n, a) {
        if (s.checkJson(e)) return a(s.message('phoneAuthenticationModel'));
        var l = {};
        s.isNull(t) || (l.fields = t),
          s.isNull(i) || (l.loginUrl = i),
          s.isNull(n) || (l.smsTemplate = n);
        return s.xhttpCall('POST', 'identity/v2/auth/login', l, e, a);
      },
      forgotPasswordByPhoneOTP: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('phone'));
        var n = {};
        s.isNull(t) || (n.smsTemplate = t);
        var a = {};
        a.phone = e;
        return s.xhttpCall('POST', 'identity/v2/auth/password/otp', n, a, i);
      },
      resetPasswordByPhoneOTP: function (e, t) {
        if (s.checkJson(e)) return t(s.message('resetPasswordByOTPModel'));
        return s.xhttpCall('PUT', 'identity/v2/auth/password/otp', {}, e, t);
      },
      phoneVerificationByOTP: function (e, t, i, n, a) {
        if (s.isNull(e)) return a(s.message('otp'));
        if (s.isNull(t)) return a(s.message('phone'));
        var l = {};
        (l.otp = e),
          s.isNull(i) || (l.fields = i),
          s.isNull(n) || (l.smsTemplate = n);
        var r = {};
        r.phone = t;
        return s.xhttpCall('PUT', 'identity/v2/auth/phone/otp', l, r, a);
      },
      phoneVerificationOTPByAccessToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('otp'));
        var a = {};
        (a.access_token = e), (a.otp = t), s.isNull(i) || (a.smsTemplate = i);
        return s.xhttpCall('PUT', 'identity/v2/auth/phone/otp', a, {}, n);
      },
      phoneResendVerificationOTP: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('phone'));
        var n = {};
        s.isNull(t) || (n.smsTemplate = t);
        var a = {};
        a.phone = e;
        return s.xhttpCall('POST', 'identity/v2/auth/phone/otp', n, a, i);
      },
      phoneResendVerificationOTPByToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('phone'));
        var a = {};
        (a.access_token = e), s.isNull(i) || (a.smsTemplate = i);
        var l = {};
        l.phone = t;
        return s.xhttpCall('POST', 'identity/v2/auth/phone/otp', a, l, n);
      },
      updatePhoneNumber: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('phone'));
        var a = {};
        (a.access_token = e), s.isNull(i) || (a.smsTemplate = i);
        var l = {};
        l.phone = t;
        return s.xhttpCall('PUT', 'identity/v2/auth/phone', a, l, n);
      },
      checkPhoneNumberAvailability: function (e, t) {
        if (s.isNull(e)) return t(s.message('phone'));
        var i = {};
        i.phone = e;
        return s.xhttpCall('GET', 'identity/v2/auth/phone', i, {}, t);
      },
      removePhoneIDByAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall('DELETE', 'identity/v2/auth/phone', i, {}, t);
      },
      userRegistrationByPhone: function (e, t, i, n, a, l, r, o) {
        if (s.checkJson(e)) return o(s.message('authUserRegistrationModel'));
        if (s.isNull(t)) return o(s.message('sott'));
        var u = {};
        (u.sott = t),
          s.isNull(i) || (u.fields = i),
          s.isNull(n) || (u.options = n),
          s.isNull(a) || (u.smsTemplate = a),
          s.isNull(l) || (u.verificationUrl = l),
          s.isNull(r) || (u.welcomeEmailTemplate = r);
        return s.xhttpCall('POST', 'identity/v2/auth/register', u, e, o);
      },
    }),
    (r.riskBasedAuthenticationApi = {}),
    (r.riskBasedAuthenticationApi = {
      rbaLoginByEmail: function (
        e,
        t,
        i,
        n,
        a,
        l,
        r,
        o,
        u,
        c,
        m,
        p,
        f,
        h,
        d,
        g,
        T,
        N,
        v,
      ) {
        if (s.checkJson(e)) return v(s.message('emailAuthenticationModel'));
        var y = {};
        s.isNull(t) || (y.emailTemplate = t),
          s.isNull(i) || (y.fields = i),
          s.isNull(n) || (y.loginUrl = n),
          null !== a && (y.passwordDelegation = a),
          s.isNull(l) || (y.passwordDelegationApp = l),
          s.isNull(r) || (y.rbaBrowserEmailTemplate = r),
          s.isNull(o) || (y.rbaBrowserSmsTemplate = o),
          s.isNull(u) || (y.rbaCityEmailTemplate = u),
          s.isNull(c) || (y.rbaCitySmsTemplate = c),
          s.isNull(m) || (y.rbaCountryEmailTemplate = m),
          s.isNull(p) || (y.rbaCountrySmsTemplate = p),
          s.isNull(f) || (y.rbaIpEmailTemplate = f),
          s.isNull(h) || (y.rbaIpSmsTemplate = h),
          s.isNull(d) || (y.rbaOneclickEmailTemplate = d),
          s.isNull(g) || (y.rbaOTPSmsTemplate = g),
          s.isNull(T) || (y.smsTemplate = T),
          s.isNull(N) || (y.verificationUrl = N);
        return s.xhttpCall('POST', 'identity/v2/auth/login', y, e, v);
      },
      rbaLoginByUserName: function (
        e,
        t,
        i,
        n,
        a,
        l,
        r,
        o,
        u,
        c,
        m,
        p,
        f,
        h,
        d,
        g,
        T,
        N,
        v,
      ) {
        if (s.checkJson(e)) return v(s.message('userNameAuthenticationModel'));
        var y = {};
        s.isNull(t) || (y.emailTemplate = t),
          s.isNull(i) || (y.fields = i),
          s.isNull(n) || (y.loginUrl = n),
          null !== a && (y.passwordDelegation = a),
          s.isNull(l) || (y.passwordDelegationApp = l),
          s.isNull(r) || (y.rbaBrowserEmailTemplate = r),
          s.isNull(o) || (y.rbaBrowserSmsTemplate = o),
          s.isNull(u) || (y.rbaCityEmailTemplate = u),
          s.isNull(c) || (y.rbaCitySmsTemplate = c),
          s.isNull(m) || (y.rbaCountryEmailTemplate = m),
          s.isNull(p) || (y.rbaCountrySmsTemplate = p),
          s.isNull(f) || (y.rbaIpEmailTemplate = f),
          s.isNull(h) || (y.rbaIpSmsTemplate = h),
          s.isNull(d) || (y.rbaOneclickEmailTemplate = d),
          s.isNull(g) || (y.rbaOTPSmsTemplate = g),
          s.isNull(T) || (y.smsTemplate = T),
          s.isNull(N) || (y.verificationUrl = N);
        return s.xhttpCall('POST', 'identity/v2/auth/login', y, e, v);
      },
      rbaLoginByPhone: function (
        e,
        t,
        i,
        n,
        a,
        l,
        r,
        o,
        u,
        c,
        m,
        p,
        f,
        h,
        d,
        g,
        T,
        N,
        v,
      ) {
        if (s.checkJson(e)) return v(s.message('phoneAuthenticationModel'));
        var y = {};
        s.isNull(t) || (y.emailTemplate = t),
          s.isNull(i) || (y.fields = i),
          s.isNull(n) || (y.loginUrl = n),
          null !== a && (y.passwordDelegation = a),
          s.isNull(l) || (y.passwordDelegationApp = l),
          s.isNull(r) || (y.rbaBrowserEmailTemplate = r),
          s.isNull(o) || (y.rbaBrowserSmsTemplate = o),
          s.isNull(u) || (y.rbaCityEmailTemplate = u),
          s.isNull(c) || (y.rbaCitySmsTemplate = c),
          s.isNull(m) || (y.rbaCountryEmailTemplate = m),
          s.isNull(p) || (y.rbaCountrySmsTemplate = p),
          s.isNull(f) || (y.rbaIpEmailTemplate = f),
          s.isNull(h) || (y.rbaIpSmsTemplate = h),
          s.isNull(d) || (y.rbaOneclickEmailTemplate = d),
          s.isNull(g) || (y.rbaOTPSmsTemplate = g),
          s.isNull(T) || (y.smsTemplate = T),
          s.isNull(N) || (y.verificationUrl = N);
        return s.xhttpCall('POST', 'identity/v2/auth/login', y, e, v);
      },
    }),
    (r.passwordLessLoginApi = {}),
    (r.passwordLessLoginApi = {
      passwordlessLoginPhoneVerification: function (e, t, i, n) {
        if (s.checkJson(e)) return n(s.message('passwordLessLoginOtpModel'));
        var a = {};
        s.isNull(t) || (a.fields = t), s.isNull(i) || (a.smsTemplate = i);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/login/passwordlesslogin/otp/verify',
          a,
          e,
          n,
        );
      },
      passwordlessLoginByPhone: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('phone'));
        var n = {};
        (n.phone = e), s.isNull(t) || (n.smsTemplate = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/passwordlesslogin/otp',
          n,
          {},
          i,
        );
      },
      passwordlessLoginByEmail: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('email'));
        var a = {};
        (a.email = e),
          s.isNull(t) || (a.passwordLessLoginTemplate = t),
          s.isNull(i) || (a.verificationUrl = i);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/passwordlesslogin/email',
          a,
          {},
          n,
        );
      },
      passwordlessLoginByUserName: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('username'));
        var a = {};
        (a.username = e),
          s.isNull(t) || (a.passwordLessLoginTemplate = t),
          s.isNull(i) || (a.verificationUrl = i);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/passwordlesslogin/email',
          a,
          {},
          n,
        );
      },
      passwordlessLoginVerification: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('verificationToken'));
        var a = {};
        (a.verificationToken = e),
          s.isNull(t) || (a.fields = t),
          s.isNull(i) || (a.welcomeEmailTemplate = i);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/login/passwordlesslogin/email/verify',
          a,
          {},
          n,
        );
      },
      passwordlessLoginVerificationByEmailAndOTP: function (e, t, i) {
        if (s.checkJson(e))
          return i(s.message('passwordLessLoginByEmailAndOtpModel'));
        var n = {};
        s.isNull(t) || (n.fields = t);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/login/passwordlesslogin/email/verifyotp',
          n,
          e,
          i,
        );
      },
      passwordlessLoginVerificationByUserNameAndOTP: function (e, t, i) {
        if (s.checkJson(e))
          return i(s.message('passwordLessLoginByUserNameAndOtpModel'));
        var n = {};
        s.isNull(t) || (n.fields = t);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/login/passwordlesslogin/username/verifyotp',
          n,
          e,
          i,
        );
      },
    }),
    (r.pinAuthenticationApi = {}),
    (r.pinAuthenticationApi = {
      pinLogin: function (e, t, i) {
        if (s.checkJson(e)) return i(s.message('loginByPINModel'));
        if (s.isNull(t)) return i(s.message('sessionToken'));
        var n = {};
        n.session_token = t;
        return s.xhttpCall('POST', 'identity/v2/auth/login/pin', n, e, i);
      },
      sendForgotPINEmailByEmail: function (e, t, i, n) {
        if (s.checkJson(e)) return n(s.message('forgotPINLinkByEmailModel'));
        var a = {};
        s.isNull(t) || (a.emailTemplate = t),
          s.isNull(i) || (a.resetPINUrl = i);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/pin/forgot/email',
          a,
          e,
          n,
        );
      },
      sendForgotPINEmailByUsername: function (e, t, i, n) {
        if (s.checkJson(e)) return n(s.message('forgotPINLinkByUserNameModel'));
        var a = {};
        s.isNull(t) || (a.emailTemplate = t),
          s.isNull(i) || (a.resetPINUrl = i);
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/pin/forgot/username',
          a,
          e,
          n,
        );
      },
      resetPINByResetToken: function (e, t) {
        if (s.checkJson(e)) return t(s.message('resetPINByResetToken'));
        return s.xhttpCall('PUT', 'identity/v2/auth/pin/reset/token', {}, e, t);
      },
      resetPINByEmailAndSecurityAnswer: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPINBySecurityQuestionAnswerAndEmailModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/pin/reset/securityanswer/email',
          {},
          e,
          t,
        );
      },
      resetPINByUsernameAndSecurityAnswer: function (e, t) {
        if (s.checkJson(e))
          return t(
            s.message('resetPINBySecurityQuestionAnswerAndUsernameModel'),
          );
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/pin/reset/securityanswer/username',
          {},
          e,
          t,
        );
      },
      resetPINByPhoneAndSecurityAnswer: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPINBySecurityQuestionAnswerAndPhoneModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/pin/reset/securityanswer/phone',
          {},
          e,
          t,
        );
      },
      sendForgotPINSMSByPhone: function (e, t, i) {
        if (s.checkJson(e)) return i(s.message('forgotPINOtpByPhoneModel'));
        var n = {};
        s.isNull(t) || (n.smsTemplate = t);
        return s.xhttpCall('POST', 'identity/v2/auth/pin/forgot/otp', n, e, i);
      },
      changePINByAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t)) return i(s.message('changePINModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall('PUT', 'identity/v2/auth/pin/change', n, t, i);
      },
      resetPINByPhoneAndOtp: function (e, t) {
        if (s.checkJson(e)) return t(s.message('resetPINByPhoneAndOTPModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/pin/reset/otp/phone',
          {},
          e,
          t,
        );
      },
      resetPINByEmailAndOtp: function (e, t) {
        if (s.checkJson(e)) return t(s.message('resetPINByEmailAndOtpModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/pin/reset/otp/email',
          {},
          e,
          t,
        );
      },
      resetPINByUsernameAndOtp: function (e, t) {
        if (s.checkJson(e))
          return t(s.message('resetPINByUsernameAndOtpModel'));
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/pin/reset/otp/username',
          {},
          e,
          t,
        );
      },
      setPINByPinAuthToken: function (e, t, i) {
        if (s.checkJson(e)) return i(s.message('pINRequiredModel'));
        if (s.isNull(t)) return i(s.message('pinAuthToken'));
        var n = {};
        n.pinAuthToken = t;
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/pin/set/pinauthtoken',
          n,
          e,
          i,
        );
      },
      inValidatePinSessionToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('sessionToken'));
        var i = {};
        i.session_token = e;
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/session_token/invalidate',
          i,
          {},
          t,
        );
      },
    }),
    (r.reAuthenticationApi = {}),
    (r.reAuthenticationApi = {
      mfaReAuthenticate: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        var n = {};
        (n.access_token = e), s.isNull(t) || (n.smsTemplate2FA = t);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/account/reauth/2fa',
          n,
          {},
          i,
        );
      },
      mfaReAuthenticateByOTP: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t)) return i(s.message('reauthByOtpModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/reauth/2fa/otp',
          n,
          t,
          i,
        );
      },
      mfaReAuthenticateByBackupCode: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t)) return i(s.message('reauthByBackupCodeModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/reauth/2fa/backupcode',
          n,
          t,
          i,
        );
      },
      mfaReAuthenticateByGoogleAuth: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t))
          return i(s.message('reauthByGoogleAuthenticatorCodeModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/reauth/2fa/googleauthenticatorcode',
          n,
          t,
          i,
        );
      },
      mfaReAuthenticateByPassword: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.checkJson(t))
          return n(s.message('passwordEventBasedAuthModelWithLockout'));
        var a = {};
        (a.access_token = e), s.isNull(i) || (a.smsTemplate2FA = i);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/reauth/password',
          a,
          t,
          n,
        );
      },
      verifyPINAuthentication: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.checkJson(t))
          return n(s.message('pINAuthEventBasedAuthModelWithLockout'));
        var a = {};
        (a.access_token = e), s.isNull(i) || (a.smsTemplate2FA = i);
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/reauth/pin',
          a,
          t,
          n,
        );
      },
      reAuthValidateEmailOtp: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t)) return i(s.message('reauthByEmailOtpModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall(
          'PUT',
          'identity/v2/auth/account/reauth/2fa/otp/email/verify',
          n,
          t,
          i,
        );
      },
      reAuthSendEmailOtp: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('emailId'));
        var a = {};
        (a.access_token = e),
          (a.emailId = t),
          s.isNull(i) || (a.emailTemplate2FA = i);
        return s.xhttpCall(
          'GET',
          'identity/v2/auth/account/reauth/2fa/otp/email',
          a,
          {},
          n,
        );
      },
      reAuthBySecurityQuestion: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t))
          return i(s.message('securityQuestionAnswerUpdateModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall(
          'POST',
          'identity/v2/auth/account/reauth/2fa/securityquestionanswer/verify',
          n,
          t,
          i,
        );
      },
    }),
    (r.nativeSocialApi = {}),
    (r.nativeSocialApi = {
      getAccessTokenByFacebookAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('fbAccessToken'));
        var n = {};
        (n.fb_Access_Token = e), s.isNull(t) || (n.socialAppName = t);
        return s.xhttpCall('GET', 'api/v2/access_token/facebook', n, {}, i);
      },
      getAccessTokenByTwitterAccessToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('twAccessToken'));
        if (s.isNull(t)) return n(s.message('twTokenSecret'));
        var a = {};
        (a.tw_Access_Token = e),
          (a.tw_Token_Secret = t),
          s.isNull(i) || (a.socialAppName = i);
        return s.xhttpCall('GET', 'api/v2/access_token/twitter', a, {}, n);
      },
      getAccessTokenByGoogleAccessToken: function (e, t, i, n, a) {
        if (s.isNull(e)) return a(s.message('googleAccessToken'));
        var l = {};
        (l.google_Access_Token = e),
          s.isNull(t) || (l.client_id = t),
          s.isNull(i) || (l.refresh_token = i),
          s.isNull(n) || (l.socialAppName = n);
        return s.xhttpCall('GET', 'api/v2/access_token/google', l, {}, a);
      },
      getAccessTokenByGoogleJWTAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('idToken'));
        var i = {};
        i.id_Token = e;
        return s.xhttpCall('GET', 'api/v2/access_token/googlejwt', i, {}, t);
      },
      getAccessTokenByLinkedinAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('lnAccessToken'));
        var n = {};
        (n.ln_Access_Token = e), s.isNull(t) || (n.socialAppName = t);
        return s.xhttpCall('GET', 'api/v2/access_token/linkedin', n, {}, i);
      },
      getAccessTokenByFoursquareAccessToken: function (e, t) {
        if (s.isNull(e)) return t(s.message('fsAccessToken'));
        var i = {};
        i.fs_Access_Token = e;
        return s.xhttpCall('GET', 'api/v2/access_token/foursquare', i, {}, t);
      },
      getAccessTokenByAppleIdCode: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('code'));
        var n = {};
        (n.code = e), s.isNull(t) || (n.socialAppName = t);
        return s.xhttpCall('GET', 'api/v2/access_token/apple', n, {}, i);
      },
      getAccessTokenByWeChatCode: function (e, t) {
        if (s.isNull(e)) return t(s.message('code'));
        var i = {};
        i.code = e;
        return s.xhttpCall('GET', 'api/v2/access_token/wechat', i, {}, t);
      },
      getAccessTokenByGoogleAuthCode: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('googleAuthcode'));
        var n = {};
        (n.google_authcode = e), s.isNull(t) || (n.socialAppName = t);
        return s.xhttpCall('GET', 'api/v2/access_token/google', n, {}, i);
      },
    }),
    (r.consentManagementApi = {}),
    (r.consentManagementApi = {
      submitConsentByConsentToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('consentToken'));
        if (s.checkJson(t)) return i(s.message('consentSubmitModel'));
        var n = {};
        n.consentToken = e;
        return s.xhttpCall('POST', 'identity/v2/auth/consent', n, t, i);
      },
      getConsentLogs: function (e, t) {
        if (s.isNull(e)) return t(s.message('accessToken'));
        var i = {};
        i.access_token = e;
        return s.xhttpCall('GET', 'identity/v2/auth/consent/logs', i, {}, t);
      },
      submitConsentByAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t)) return i(s.message('consentSubmitModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall('POST', 'identity/v2/auth/consent/profile', n, t, i);
      },
      verifyConsentByAccessToken: function (e, t, i, n) {
        if (s.isNull(e)) return n(s.message('accessToken'));
        if (s.isNull(t)) return n(s.message('event'));
        var a = {};
        (a.access_token = e), (a.event = t), (a.isCustom = i);
        return s.xhttpCall('GET', 'identity/v2/auth/consent/verify', a, {}, n);
      },
      updateConsentProfileByAccessToken: function (e, t, i) {
        if (s.isNull(e)) return i(s.message('accessToken'));
        if (s.checkJson(t)) return i(s.message('consentUpdateModel'));
        var n = {};
        n.access_token = e;
        return s.xhttpCall('PUT', 'identity/v2/auth/consent', n, t, i);
      },
    }),
    (r.getToken = function () {
      return u(n);
    }),
    (r.getApiKey = function () {
      if (u('lrApiKey')) return u('lrApiKey');
      console.log(
        'API Key not found, The API Key needs to be initialized for this API Call',
      );
    }),
    (s.isNull = function (e) {
      return !(null != e && e);
    }),
    (s._uuidFormat =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i),
    (s.checkJson = function (e) {
      return null == e || Array.isArray(e) || 'object' != typeof e;
    }),
    (s.message = function (e) {
      return (
        (l[1e3].Description =
          'The API Request Paramter ' + e + ' is not Correct or WellFormated'),
        l[1e3]
      );
    }),
    (s.log = function (e) {
      a.debugMode && 'undefined' != typeof console && console.error(e);
    }),
    (s.xhttpCall = function (e, t, n, r, o) {
      if (a.apiKey) {
        -1 != t.indexOf('/v2/access_token/')
          ? (n.key = a.apiKey)
          : (n.ApiKey = a.apiKey);
        var u = new XMLHttpRequest();
        if (
          ((u.onreadystatechange = function () {
            if (4 == this.readyState && 200 == this.status) {
              var e = JSON.parse(u.responseText);
              e && e.ErrorCode ? o(e) : o('', e);
            } else 4 == this.readyState && 429 == this.status && o(l[429]);
          }),
          'ciam/appinfo' == t && (i = 'https://config.lrcontent.com'),
          n.access_token)
        ) {
          var c = n.access_token;
          delete n.access_token;
        }
        if (n.sott) {
          var m = n.sott;
          delete n.sott;
        }
        u.open(e, i + '/' + t + '?' + s.makeQuerySting(n)),
          c && (u.setRequestHeader('authorization', 'Bearer ' + c), (c = '')),
          m && (u.setRequestHeader('X-LoginRadius-Sott', m), (m = '')),
          a.originIp && u.setRequestHeader('X-Origin-IP', a.originIp),
          u.setRequestHeader('Content-type', 'application/json'),
          u.setRequestHeader('X-Requested-With', 'XMLHttpRequest'),
          (u.onerror = function () {
            o(l[1e3]);
          }),
          u.send(JSON.stringify(r));
      } else s.log('Please set the LoginRadius ApiKey'), o(l[1e3]);
    }),
    (s.makeQuerySting = function (e) {
      var t = [];
      for (var i in e)
        t.push(encodeURIComponent(i) + '=' + encodeURIComponent(e[i]));
      return t.join('&');
    }),
    (s.addEvent = function (e, t, i) {
      var n = [];
      t instanceof Array ? (n = t) : n.push(t);
      for (var s = 0; s < n.length; s++)
        n[s].attachEvent
          ? n[s].attachEvent('on' + e, function (e) {
              i(e);
            })
          : n[s].addEventListener && n[s].addEventListener(e, i, !1);
    }),
    s.addEvent('message', window, function (e) {
      if (-1 == e.origin.indexOf('hub.loginradius.com')) return;
      c(e.data);
    });
  var c = function (e) {
    sessionStorage.setItem(n, e), (r.isauthenticated = !0);
    var t = setInterval(function () {
      r.onlogin && (r.onlogin(), clearInterval(t));
    }, 100);
  };
  var m = hash.get('lr-token');
  return (
    m &&
      (window.opener && window.opener.loginradiushtml5passToken
        ? (window.opener.loginradiushtml5passToken(m),
          document.write(
            '<style type="text/css">body { display: none !important; } </style>',
          ),
          window.close())
        : window.loginradiushtml5passToken(m)),
    (r.initSDK = function (e) {
      var i, n, s;
      (a.apiKey = e.apiKey),
        (a.debugMode = e.debugMode || !1),
        (a.originIp = e.originIp),
        (i = 'lrApiKey'),
        (n = e.apiKey),
        (s = !0),
        o('localStorage') && (localStorage.setItem(i, n), (s = !1)),
        o('sessionStorage') && (sessionStorage.setItem(i, n), (s = !1)),
        s && t(i, n, '', window.location);
    }),
    r
  );
})();
